import * as configUtils from "util/config";

export const invitationCodeMask = () => {
    const invitationCodeUnmaskedLength = configUtils.getInteger("backoffice.invitationCodes.unmaskedLength", 4);

    let mask = new Array(invitationCodeUnmaskedLength).fill(/[a-zA-Z\d]/);
    for (let i = 0; i < 2; i++) {
        mask = [...mask, "-", ...new Array(invitationCodeUnmaskedLength).fill(/[a-zA-Z\d]/)];
    }

    return mask;
};

export const timeCodeMask = () => [/\d/, /\d/, ":", /\d/, /\d/];

export const timeRegex = () => "^(?:0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$";

export const emailMask = (email) => {
    const array = email.split("@");
    const user = array[0];
    const domain = array[1];

    const maskedUser = email.replace(/([^@\.])/g, "*").split("");
    const maskedDomain = email.replace(/([^@\.])/g, "*").split("");
    for (let i = 0; i < maskedUser.length; i++) {
        if (i <= 1 || i > user.length - 2) {
            maskedUser[i] = user[i];
        }
    }

    for (let i = 0; i < maskedDomain.length; i++) {
        if (i < 1 || i > domain.length - 5) {
            maskedDomain[i] = domain[i];
        }
    }

    return `${maskedUser.join("")}@${maskedDomain.join("")}`;
};

export default {};
